<template>

    <ValidationObserver ref="form">
        <loading :active.sync="isLoading"
                 :is-full-page="fullPage"
                 color="#00F">
        </loading>
        <b-row>
            <b-col sm="12">
                <h5 class="h5-color">
                    <span class="header-icon"><i class="nav-icon icon-direction"></i></span>
                    Your Vehicle Details
                </h5>
            </b-col>
        </b-row>
        <ValidationProvider
                vid="vehicle_type"
                name="Vehicle Type"
                v-slot="{ errors }"
                rules=""
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Vehicle Type <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Title -->
                            <b-col md="12" class="">
                                <v-select
                                        label="name"
                                        @input="setVehicleType"
                                        :options="vehicle_type_list"
                                        :reduce="data => data.code"
                                        :value="VehicleData.vehicle_type"
                                        placeholder="--PLEASE SELECT--"
                                ></v-select>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="vehicle_usage"
                name="Usage Of Vehicle"
                v-slot="{ errors }"
                rules=""
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Usage Of Vehicle <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Title -->
                            <b-col md="12" class="">
                                <v-select
                                        label="name"
                                        @input="setVehicleUsage"
                                        :options="vehicle_usage_list"
                                        :reduce="data => data.code"
                                        :value="VehicleData.vehicle_usage"
                                        placeholder="--PLEASE SELECT--"
                                ></v-select>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="fuel_type"
                name="Fuel Type"
                v-slot="{ errors }"
                rules=""
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Fuel Type <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Title -->
                            <b-col md="12" class="">
                                <v-select
                                        label="name"
                                        @input="setVehicleFuelType"
                                        :options="fuel_type_list"
                                        :reduce="data => data.code"
                                        :value="VehicleData.fuel_type"
                                        placeholder="--PLEASE SELECT--"
                                ></v-select>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="year_of_make"
                name="Year of Make"
                v-slot="{ errors }"
                rules=""
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Year of Make <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Title -->
                            <b-col md="12" class="">
                                <v-select
                                        label="name"
                                        @input="setYearOfMake"
                                        :options="year_of_make_list"
                                        :reduce="data => data.code"
                                        :value="VehicleData.year_of_make"
                                        placeholder="--PLEASE SELECT--"
                                ></v-select>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="vehicle_make"
                name="Make"
                v-slot="{ errors }"
                rules=""
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Make <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Title -->
                            <b-col md="12" class="">
                                <v-select
                                        label="name"
                                        @input="setVehicleMake"
                                        :options="vehicle_make_list"
                                        :reduce="data => data.code"
                                        :value="VehicleData.vehicle_make"
                                        placeholder="--PLEASE SELECT--"
                                ></v-select>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="vehicle_model"
                name="Model"
                v-slot="{ errors }"
                rules=""
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Model <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Title -->
                            <b-col md="12" class="">
                                <v-select
                                        label="name"
                                        @input="setVehicleModel"
                                        :options="vehicle_model_list"
                                        :reduce="data => data.code"
                                        :value="VehicleData.vehicle_model"
                                        placeholder="--PLEASE SELECT--"
                                ></v-select>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="chassis_no"
                name="Chassis No"
                v-slot="{ errors }"
                rules="">
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Chassis No <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Passport Number -->
                            <b-col md="12" class="">
                                <b-form-input
                                        v-model="VehicleData.chassis_no"
                                        type="text"
                                        id="input-large"
                                        size="lg"
                                        placeholder="Chassis No"
                                        @change="draftProposalData"
                                        class="to-uppercase"
                                        v-uppercase></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="engine_no"
                name="Engine No"
                v-slot="{ errors }"
                rules=""
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Engine No <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Passport Number -->
                            <b-col md="12" class="">
                                <b-form-input
                                        v-model="VehicleData.engine_no"
                                        type="text"
                                        id="input-large"
                                        size="lg"
                                        placeholder="Engine No"
                                        @change="draftProposalData"
                                        class="to-uppercase"
                                        v-uppercase></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="cubic_capacity"
                name="Cubic Capacity"
                v-slot="{ errors }"
                rules="integer"
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Cubic Capacity <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Passport Number -->
                            <b-col md="12" class="">
                                <b-form-input
                                        v-model="VehicleData.cubic_capacity"
                                        type="number"
                                        id="input-large"
                                        size="lg"
                                        placeholder="Cubic Capacity"
                                        @change="draftProposalData"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="seating_capacity"
                name="Seating Capacity"
                v-slot="{ errors }"
                rules="integer"
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Seating Capacity (including driver) <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Passport Number -->
                            <b-col md="12" class="">
                                <b-form-input
                                        v-model="VehicleData.seating_capacity"
                                        type="number"
                                        id="input-large"
                                        size="lg"
                                        placeholder="Seating Capacity (including driver)"
                                        @change="draftProposalData"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationObserver ref="accessories_form">
            <b-row class="row-bottom">
                <b-col sm="12" md="12">
                    <label class="label-name">Accessories / extra fittings installed in the vehicle (other than factory
                        fitted)</label>
                </b-col>

                <b-col class="col-md-12" cols="12">
                    <b-row>
                        <b-col md="4" sm="12">
                            <ValidationProvider
                                    vid="ac_description"
                                    name="Item Description"
                                    v-slot="{ errors }"
                                    rules="">
                                <b-form-input
                                        v-model="ac_description"
                                        type="text"
                                        id="ac_description"
                                        size="lg"
                                        placeholder="Item Description"
                                        class="to-uppercase"
                                        v-uppercase></b-form-input>
                                <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                    {{ error }}
                                </span>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4" sm="12">
                            <ValidationProvider
                                    vid="ac_value"
                                    name="Item Value"
                                    v-slot="{ errors }"
                                    rules="">
                                <b-form-input
                                        @keypress="isNumber($event)"
                                        v-model="ac_value"
                                        type="number"
                                        id="ac_value"
                                        size="lg"
                                        placeholder="Item Value"
                                ></b-form-input>
                                <span class="under-error-messages" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                            </span>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-button type="button" block variant="primary" size="lg" v-on:click="addVehicleItems()">
                                Add
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
        <b-row class="row-bottom" v-if="VehicleData.vehicleAccessories">
            <b-col sm="8" md="8">
                <table class="table table-bordered table-responsive-md">
                    <thead>
                        <th>Description</th>
                        <th>Value</th>
                        <th>Action</th>
                    </thead>
                    <tr v-for="item in VehicleData.vehicleAccessories">
                        <td>{{ item.description }}</td>
                        <td>{{ item.value }}</td>
                        <td style="width: 10%;">
                            <i data-v-546b4a34="" class="nav-icon icon-trash item-remove-btn" v-on:click="deleteVehicleItem(item)"></i>
<!--                            <b-button type="button" block variant="danger" size="xs"-->
<!--                                      v-on:click="deleteVehicleItem(item)">remove-->
<!--                            </b-button>-->
                        </td>
                    </tr>
                </table>

            </b-col>
        </b-row>
        <ValidationProvider
                vid="market_value"
                name="Present market value"
                v-slot="{ errors }"
                rules="required"
        >
            <b-row class="row-bottom">
                <b-col sm="8" md="8">
                    <label class="label-name">Present market value <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <!-- Passport Number -->
                            <b-col md="12" class="">
                                <b-form-input
                                        @keypress="isNumber($event)"
                                        v-model="VehicleData.market_value"
                                        type="number"
                                        id="input-large"
                                        size="lg"
                                        placeholder="Present market value"
                                        @change="draftProposalData"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                      <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                        {{ error }}
                      </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>


        <ValidationProvider
                vid="is_vehicle_imported_duty_free"
                name="If Vehicle Imported Duty Free"
                v-slot="{ errors }"
                rules=""
        >
            <b-row class="term-section">
                <b-col md="3">
                    <label class="label-name-cover">If Vehicle imported “DUTY FREE” or Concessionary Duty <span style="color:red">*</span></label>
                </b-col>

                <b-col md="5">
                    <p-radio class="p-default p-curve p-bigger" @change="draftProposalData"
                             v-model="VehicleData.is_vehicle_imported_duty_free" value="1"
                             name="is_vehicle_imported_duty_free" color="primary-o">Yes
                    </p-radio>
                    <p-radio class="p-default p-curve p-bigger" @change="draftProposalData"
                             v-model="VehicleData.is_vehicle_imported_duty_free" value="0"
                             name="is_vehicle_imported_duty_free" color="danger-o">No
                    </p-radio>
                </b-col>

                <b-col md="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg agreement-validation-custom" v-if="!errors[0]">
                          <span class="msg-paragraph">
                              <span style="color:red">*</span>This field is required
                          </span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg agreement-validation-custom">
                        <span class="msg-paragraph"
                              v-for="(error, index) in errors"
                              v-bind:key="index">
                          {{ error }}
                        </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="imported_value"
                name="Vehicle Imported Details"
                v-slot="{ errors }"
                rules=""
                v-show="VehicleData.is_vehicle_imported_duty_free ==1"
        >
            <b-row class="row-bottom">
                <b-col md="8">
                    <label class="label-name">Vehicle Imported Details <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <b-col md="12" class="">
                                <b-form-textarea
                                        v-model="VehicleData.imported_value"
                                        placeholder="Please enter the value"
                                        rows="3"
                                        @change="draftProposalData"
                                        class="to-uppercase"
                                        v-uppercase></b-form-textarea>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph">
                            <span style="color:red">*</span>This field is required
                        </span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                        <span class="msg-paragraph"
                              v-for="(error, index) in errors"
                              v-bind:key="index">
                          {{ error }}
                        </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>

        <ValidationProvider
                vid="is_the_vehicle_modified"
                name="Is the Vehicle modified in any manner"
                v-slot="{ errors }"
                rules="">
            <b-row class="term-section">
                <b-col md="3">
                    <label class="label-name-cover">Is the Vehicle modified in any manner? <span style="color:red">*</span></label>
                </b-col>

                <b-col md="5">
                    <p-radio class="p-default p-curve p-bigger" @change="draftProposalData"
                             v-model="VehicleData.is_the_vehicle_modified" value="1" name="is_the_vehicle_modified"
                             color="primary-o">Yes
                    </p-radio>
                    <p-radio class="p-default p-curve p-bigger" @change="draftProposalData"
                             v-model="VehicleData.is_the_vehicle_modified" value="0" name="is_the_vehicle_modified"
                             color="danger-o">No
                    </p-radio>
                </b-col>

                <b-col md="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg agreement-validation-custom" v-if="!errors[0]">
                            <span class="msg-paragraph">
                                <span style="color:red">*</span>This field is required
                            </span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg agreement-validation-custom">
                        <span class="msg-paragraph"
                              v-for="(error, index) in errors"
                              v-bind:key="index">
                          {{ error }}
                        </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="vehicle_modified_details"
                name="Vehicle Modified Details"
                v-slot="{ errors }"
                rules=""
                v-show="VehicleData.is_the_vehicle_modified == 1"
        >
            <b-row class="row-bottom">

                <b-col md="8">
                    <label class="label-name">Vehicle Modified Details <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <b-col md="12" class="">
                                <b-form-textarea
                                        v-model="VehicleData.vehicle_modified_details"
                                        placeholder="Enter Vehicle Modified Details"
                                        rows="3"
                                        @change="draftProposalData"
                                        class="to-uppercase"
                                        v-uppercase></b-form-textarea>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph">
                            <span style="color:red">*</span>This field is required
                        </span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                        <span class="msg-paragraph"
                              v-for="(error, index) in errors"
                              v-bind:key="index">
                          {{ error }}
                        </span>
                    </div>
                </b-col>

            </b-row>
        </ValidationProvider>

        <ValidationProvider
                vid="is_vehicle_in_good_condition"
                name="Is the vehicle presently in good condition"
                v-slot="{ errors }"
                rules=""
        >
            <b-row class="term-section">
                <b-col md="3">
                    <label class="label-name-cover">Is the vehicle presently in good condition? <span style="color:red">*</span></label>
                </b-col>

                <b-col md="5">
                    <p-radio class="p-default p-curve p-bigger" @change="draftProposalData"
                             v-model="VehicleData.is_vehicle_in_good_condition" value="1"
                             name="is_vehicle_in_good_condition" color="primary-o">Yes
                    </p-radio>
                    <p-radio class="p-default p-curve p-bigger" @change="draftProposalData"
                             v-model="VehicleData.is_vehicle_in_good_condition" value="0"
                             name="is_vehicle_in_good_condition" color="danger-o">No
                    </p-radio>
                </b-col>

                <b-col md="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg agreement-validation-custom" v-if="!errors[0]">
                            <span class="msg-paragraph">
                                <span style="color:red">*</span>This field is required
                            </span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg agreement-validation-custom">
                        <span class="msg-paragraph"
                              v-for="(error, index) in errors"
                              v-bind:key="index">
                          {{ error }}
                        </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
        <ValidationProvider
                vid="vehicle_condition"
                name="Vehicle Condition Details"
                v-slot="{ errors }"
                rules=""
                v-show="VehicleData.is_vehicle_in_good_condition == 0"
        >
            <b-row class="term-section">

                <b-col md="8">
                    <label class="label-name">Vehicle Condition Details <span style="color:red">*</span></label>
                    <b-form-group>
                        <b-row>
                            <b-col md="12" class="">
                                <b-form-textarea
                                        v-model="VehicleData.vehicle_condition"
                                        placeholder="Enter Vehicle Condition Details"
                                        rows="3"
                                        @change="draftProposalData"
                                        class="to-uppercase"
                                        v-uppercase></b-form-textarea>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <label class="label-name empty-label"></label>
                    <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                        <span class="msg-paragraph">
                            <span style="color:red">*</span>This field is required
                        </span>
                    </div>
                    <div v-else class="msg-fail validation-form-msg">
                        <span class="msg-paragraph"
                              v-for="(error, index) in errors"
                              v-bind:key="index">
                          {{ error }}
                        </span>
                    </div>
                </b-col>
            </b-row>
        </ValidationProvider>
    </ValidationObserver>

</template>

<script>
    import {mapState, mapActions} from "vuex";
    import {http} from "@/config/http";
    import Tables from "../../../backend/LogResults";

    export default {
        components: {Tables},
        data() {
            return {
                ac_description: '',
                ac_value: '',
                isLoading: false,
                fullPage: true,
            };
        },
        computed: {
            ...mapState("proposal", [
                "customer_errors",
                "ProposerData",
                "VehicleData",
                "vehicle_type_list",
                "vehicle_usage_list",
                "fuel_type_list",
                "year_of_make_list",
                "vehicle_make_list",
                "vehicle_model_list",
                "vehicle_no_format_list",
                "proposal_id"
            ]),
        },
        methods: {
            ...mapActions("proposal", [
                "setVehicleType",
                "setVehicleUsage",
                "setVehicleFuelType",
                "setYearOfMake",
                "setVehicleMake",
                "setVehicleModel",
                "setVehicleNoFormat",
                "getParameterDataList",
                "getMakeYearList",
                "getCoverList",
                "getExtraFittings",
                "addExtraFittings",
                "removeExtraFittings",
                "draftProposalData",
                "draftCoverData"
            ]),
            addVehicleItems: function () {

                return new Promise((resolve, reject) => {
                    this.$refs.accessories_form.validate().then(valid => {
                        if (valid) {
                            this.isLoading = true;
                            let obj = {};
                            obj.ac_description = this.ac_description;
                            obj.ac_value = this.ac_value;
                            obj.proposal_id = this.proposal_id
                            //this.VehicleData.vehicleAccessories.push(obj);

                            this.addExtraFittings(obj).then((response) => {
                                if (!response.data.errors) {
                                    const data = {
                                        proposal_id: this.proposal_id
                                    };
                                    this.getExtraFittings(data).then((response) => {
                                        this.isLoading = false;
                                    });
                                    this.ac_description = '';
                                    this.ac_value = '';
                                  this.$snotify.success(response.data.message, "", {
                                    position: "centerTop",
                                  });

                                }else{
                                    this.isLoading = false;
                                    this.$snotify.error(response.data.errors.message, "", {
                                      position: "centerTop",
                                    });
                                }
                            });
                        } else {
                            //this.$refs.basic_form.setErrors(response.data.errors);
                        }
                    });
                });


            },
            deleteVehicleItem: function (item) {
                this.isLoading = true;
                this.removeExtraFittings(item).then((response) => {
                    if (!response.error) {
                        const data = {
                            proposal_id: this.proposal_id
                        };
                        this.getExtraFittings(data).then((response) => {
                            this.isLoading = false;
                        });
                    }

                });
            },
            draftCoverTable(){
                this.draftCoverData();
            },
            async getVehicleUsageList() {
                let table = 'param_vehicle_usage';
                const data = {
                    table: table,
                    type: 'vehicle_usage_list',
                    extra_params: [{"vehicle_type": this.VehicleData.vehicle_type , "logic_type" : 1}]
                };
                await this.getParameterDataList(data);
            },
            async getFuelTypeList() {
              let table = 'param_fuel_types';
              const data = {
                table: table,
                type: 'fuel_type_list',
                extra_params: [{"vehicle_type": this.VehicleData.vehicle_type , "logic_type" : 2}]
              };
              await this.getParameterDataList(data);
            },
            async getVehicleModelList() {
                let table = 'param_vehicle_model';
                const data = {
                    table: table,
                    type: 'vehicle_model_list',
                    where: [{"field": "make_id", "operator": "=", "value": this.VehicleData.vehicle_make}]
                };
                await this.getParameterDataList(data);
            },
            isNumber: function(evt) {
              evt = evt ? evt : window.event;
              var charCode = evt.which ? evt.which : evt.keyCode;
              if (
                  charCode > 31 &&
                  (charCode < 48 || charCode > 57) &&
                  charCode !== 46
              ) {
                evt.preventDefault();
              } else {
                return true;
              }
            },

        },
        mounted() {

        },
        created() {

        },
        watch: {
            'VehicleData.vehicle_make': function (val, oldval) {
                //this.VehicleData.vehicle_model = '';
                this.getVehicleModelList();
                this.draftProposalData();
            },
            'VehicleData.vehicle_model': function (val, oldval) {
                this.draftProposalData();
            },
            'VehicleData.fuel_type': function (val, oldval) {
                this.draftProposalData().then(() => {
                    //this.draftCoverTable();
                });
            },
            'VehicleData.year_of_make': function (val, oldval) {
                this.draftProposalData();
            },
            'VehicleData.vehicle_usage': function (val, oldval) {
                this.draftProposalData().then(() => {
                    //this.draftCoverTable();
                });
            },
            'VehicleData.vehicle_type': function (val, oldval) {
                this.getVehicleUsageList();
                this.getFuelTypeList();
                this.draftProposalData().then(() => {
                    //this.draftCoverTable();
                });
            }
        },
    };
</script>

<style scoped>

    .to-uppercase{
        text-transform: uppercase
    }

    .item-remove-btn{
        color: #f25c5c;
        font-weight: bold;
    }

    .item-remove-btn:hover{
        cursor: pointer;
    }

    .under-error-messages {
        color: #dd2f2f;
        font-weight: bold;
        font-size: 12px;
    }

    input::placeholder {
        font-size: 14px;
    }

    .agreement-validation-custom {
        margin-top: -20px !important;
    }

    .msg-secound-line {
        margin-top: 0px;
    }

    .custom-select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

    .toggle-button {
        margin: 0 20px;
    }

    /*
         * Toggle button styles
         */
    .toggle-button {
        position: relative;
        display: inline-block;
        color: #fff;
    }

    .toggle-button label {
        display: inline-block;
        text-transform: uppercase;
        cursor: pointer;
        text-align: left;
    }

    .toggle-button input {
        display: none;
    }

    .toggle-button__icon {
        cursor: pointer;
        pointer-events: none;
    }

    .toggle-button__icon:before,
    .toggle-button__icon:after {
        content: "";
        position: absolute;
        top: 45%;
        left: 35%;
        transition: 0.2s ease-out;
    }

    /*
         * Toggle button variables
         */
    /*
         * Toggle button styles
         */
    .toggle-button--aava label {
        height: 50px;
        line-height: 50px;
        transition: all 0.2s;
        border-radius: 2rem;
    }

    .toggle-button--aava label:before,
    .toggle-button--aava label:after {
        position: absolute;
        right: 1.5rem;
        transition: all 0.2s 0.1s ease-out;
    }

    .toggle-button--aava label:before {
        content: attr(data-on-text);
    }

    .toggle-button--aava label:after {
        content: attr(data-off-text);
    }

    .toggle-button--aava input[type="checkbox"] + label {
        width: 120px;
        background: #ff5335;
    }

    .toggle-button--aava input[type="checkbox"] + label:before {
        opacity: 0;
        transform: translate(0, 20px);
    }

    .toggle-button--aava input[type="checkbox"] + label:after {
        opacity: 1;
        transform: translate(0, 0);
    }

    .toggle-button--aava input[type="checkbox"]:checked ~ label {
        width: 120px;
        background: #61b136;
    }

    .toggle-button--aava input[type="checkbox"]:checked ~ label:before {
        opacity: 1;
        transform: translate(0, 0);
    }

    .toggle-button--aava input[type="checkbox"]:checked ~ label:after {
        opacity: 0;
        transform: translate(0, -20px);
    }

    .toggle-button--aava
    input[type="checkbox"]:checked
    ~ .toggle-button__icon:before {
        transform: translate(-10%, 100%) rotate(45deg);
        width: 16.66667px;
    }

    .toggle-button--aava
    input[type="checkbox"]:checked
    ~ .toggle-button__icon:after {
        transform: translate(30%) rotate(-45deg);
    }

    .toggle-button--aava .toggle-button__icon {
        position: absolute;
        left: 0;
        top: 0;
        height: 50px;
        width: 50px;
    }

    .toggle-button--aava .toggle-button__icon:before,
    .toggle-button--aava .toggle-button__icon:after {
        height: 3px;
        border-radius: 3px;
        background: #fff;
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
    }

    .toggle-button--aava .toggle-button__icon:before {
        width: 25px;
        transform: rotate(45deg);
    }

    .toggle-button--aava .toggle-button__icon:after {
        width: 25px;
        transform: rotate(-45deg);
    }

    .hide {
        display: none;
    }

    .selected_val {
        color: #fff !important;
        background-color: #4b78be !important;
    }

    p {
        color: #717887;
        margin-top: -15px;
        margin-left: 2px;
    }

    .check {
        opacity: 0.5;
        color: #996;
    }

    .box {
        margin-bottom: 5px;
    }

    input[type="radio"],
    input[type="checkbox"] {
        box-sizing: border-box;
        padding: 0;
        display: none;
    }

    img {
        width: 100px;
    }

    .img-thumbnail {
        border: 1px solid #4b78be !important;
        background-color: #ffffff !important;
    }

    .btn-outline {
        border: 1px solid #4b78be !important;
    }

    .btn-pad {
        padding: 0 !important;
    }

    .btn {
        border: solid 0px #e4e7ea;
        border-radius: 0.3rem !important;
    }

    .btn-sq {
        width: 98px !important;
        height: 66px !important;
        font-size: 12px;
        color: #4b78be;
        background-color: #ffffff;
        margin-top: 2px;
    }

    .btn-sqw {
        width: 98px !important;
        height: 105px !important;
        font-size: 12px;
        color: #4b78be;
        background-color: #ffffff;
        margin-top: 2px;
    }

    .btn-ch {
        width: 55px !important;
        height: 58px !important;
        font-size: 12px;
        color: #4b78be;
        background-color: #ffffff;
    }

    .label-name {
        font-weight: bold;
        color: #31607b;
        margin-bottom: 15px !important;
    }

    .label-name-cover {
        font-weight: bold;
        color: #31607b;
        margin-bottom: 15px !important;
    }

    .label-align {
        text-align: right;
    }

    hr {
        margin-top: 1px !important;
        margin-bottom: 20px !important;
    }

    /* start of validation msg css */

    .msg {
        border: 1px solid #d8e1eb;
        border-radius: 0.2rem;
        padding: 12px;
        background: #f2f6fa;
        margin-bottom: 18px;
        color: #656d7d;
    }

    .msg-fail {
        border: 1px solid #ff969b;
        border-radius: 0.2rem;
        padding: 12px;
        background: #ffeef3;
        margin-bottom: 18px;
        color: #ff303a;
    }

    .msg-success {
        border: 1px solid #6ac879;
        border-radius: 0.2rem;
        padding: 12px;
        background: #eeffed;
        margin-bottom: 18px;
        color: #009b0a;
    }

    /* end ofvalidation msg css */

    .msg-paragraph {
        font-size: 12px;
    }

    .msg-paragraph-con {
        color: #656d7d;
        font-size: 12px;
        margin-top: -15px;
    }

    .msg-paragraph-con2 {
        color: #656d7d;
        font-size: 12px;
        margin-top: 15px;
    }

    .form-text-align {
        text-align: center;
    }

    .country-header {
        margin-left: 26px;
    }

    span.individual {
        background: url("~@/assets/icon/user.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 9px;
    }

    span.family {
        background: url("~@/assets/icon/family.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 9px;
    }

    span.group {
        background: url("~@/assets/icon/group.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 5px;
    }

    span.single {
        background: url("~@/assets/icon/plane.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 12px;
    }

    span.multi {
        background: url("~@/assets/icon/planes.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 2px;
    }

    span.world {
        background: url("~@/assets/icon/world.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 30px;
        width: 40px;
        margin-top: 5px;
        margin-bottom: 0px;
        margin-left: 10px;
    }

    span.fourty-five {
        /*background: url("~@/assets/icon/calendar.svg") no-repeat top left;*/
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 25px;
        width: 60px;
        margin-top: 2px;
        margin-bottom: 0px;
        margin-left: 1px;
    }

    span.ninety {
        /*background: url("~@/assets/icon/calendar.svg") no-repeat top left;*/
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 25px;
        width: 60px;
        margin-top: 2px;
        margin-bottom: 0px;
        margin-left: 1px;
    }

    .div-color {
        background-color: #fff;
        border-radius: 5px;
        width: 100%;
        padding: 0px 0px 0px 0px;
    }

    .div-button {
        display: inline-block;
        color: #444;
        border: 1px solid #4b78be;
        background: #fff;
        cursor: pointer;
        vertical-align: middle;
        width: 100%;
        padding: 15px 5px;
        border-radius: 0.3rem !important;
    }

    /*.div-button:active {
        color:red;
        box-shadow: 0 0 5px -1px rgba(0,0,0,0.6);
    }*/

    .world-area-text {
        margin-left: -5px;
        color: #4b78be;
    }

    .small-text {
        margin-top: -6px;
        color: #4b78be;
    }

    .small-text-middle {
        margin-right: -30px;
    }

    .small-text-last {
        margin-right: -30px;
    }

    .row-bottom {
        margin-bottom: 5px;
    }

    .row-bottom-tf {
        margin-bottom: 8px;
    }

    .btn-right {
        margin-right: 10px;
    }

    .btn-bottom {
        margin-bottom: 10px;
    }

    .col-width {
        width: 100px;
    }

    .col-width-d {
        width: 100px;
    }

    .col-width-m {
        width: 100px;
    }

    .col-width-y {
        width: 120px;
    }

    .globle-icon {
        margin-left: 12px;
        color: #4b78be;
        margin-top: 4px;
    }

    .form-group-bottom {
        margin-bottom: 0rem;
    }

    .modal-footer {
        display: none !important;
    }

    @media (max-width: 480px) {
        .agreement-validation-custom {
            margin-top: 10px !important;
        }
    }

    @media (max-width: 769px) {
        .label-name {
            margin-bottom: 25px;
            margin-top: 5px;
        }

        .label-name-cover {
            margin-bottom: 25px;
            margin-top: 5px;
        }

        .label-align {
            text-align: left;
        }

        .btn-right {
            margin-right: 9px;
        }

        .world-area-button {
            width: 100%;
            margin-bottom: 15px;
        }

        .world-area-button {
            width: 100%;
            margin-bottom: 10px;
            margin-right: 0px;
        }

        img {
            width: 98px;
        }

        .btn-sq {
            width: 96px !important;
        }

        .btn-sqw {
            width: 96px !important;
        }

        span.world {
            margin-left: 16px;
        }

        .col-width-d {
            width: 108px;
            margin-right: -22px;
        }

        .col-width-m {
            width: 108px;
            margin-right: -22px;
        }

        .col-width-y {
            width: 108px;
        }
    }
</style>
